import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import CompetitionsService, { CompetitionType, CompetitionTypes, CompetitionsUsersType, ListOfQuickLinks } from "../../services/CompetitionsService";
import { PrimaryButton, Spinner, SpinnerSize } from "@fluentui/react";
import styles from './index.module.sass';
import { currencyNeutreFormatter, decimalFormatter } from "../../utils/numberFormatter";
import { useHistory, useLocation } from "react-router-dom";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import portfolioModelWallets, { DataAndCartLines, ModelWallet } from "../../services/PortfolioModelWalletService";
import BackButton from "../../components/buttons/BackButton";
import CardWithInfo from "../../components/cardwithinfo/CardWithInfo";
import { CompetitionQuickLinks } from "../../components/competitionQuickLinks/CompetitionQuickLinks";
import * as L from "./layout.styles";
import CountdownTimer from "../../components/CountDownTimer/CountDownTimer";
import Auth from "../../Auth/Auth";
import { ErrorModal } from "../../components/Modals/ErrorModal";
import { SavingsPlanTypes } from "../../services/SavingsPlanService";
import { useDispatch } from "react-redux";
import { addCompetitionDataInLs, addLineEP, cartStateEP, clearCartEP, ICompetitionInfo, updateModelPortfolioIdEP, updateModelPortfolioNameEP } from "../../store/educationalcart/actions";
import { addCompetition, addCompetitionData, addLine, cartState, clearCart, updateModelPercentageTotal } from "../../store/cart/actions";
import { CartModesEP } from "../CartEducationalPlan/CartEducationalPlanScreen";
import { CartModes } from "../Cart/CartScreen";
import React from "react";

const options: Highcharts.Options =
{
    title:
    {
        text: '',
    },
    xAxis: { visible: false },
    yAxis: { visible: false },
    legend: { enabled: false },
    exporting: { enabled: false },
    credits: { enabled: false },
    chart:
    {
        type: 'bar',
        margin: 0,
        height: 24,
        backgroundColor: "transparent",
        borderColor: "transparent"
    },
    tooltip:
    {
        headerFormat: "",
        valueSuffix: '%',
        outside: true,
    },
    plotOptions:
    {
        bar:
        {
            stacking: 'percent',
            groupPadding: 0,
            pointPadding: 0,
            borderRadius: 4,
            borderColor: "transparent",
        },
    },
};

const CompetitionPromotionated = () =>
{
    let history = useHistory();
    const [competition, setCompetition] = useState<CompetitionType>();
    const [banners, setBanners] = useState<ListOfQuickLinks>({quicklinks: []});
    const [competitionUsers, setCompetitionUsers] = useState<CompetitionsUsersType[]>();
    const [series, setSeries] = useState<any[]>([]);
    const [error, setError] = useState({ status: false, message: '' });
    const [loading, setLoading] = useState<boolean>(true);
    const user: any = Auth.getUserProfile();
    const [isLoadingMOdelPortfolioToEdit, setIsLoadingModelPortfolioToEdit] = useState<boolean>(false);
    const location = useLocation();
    const isUserSuscribed = Auth.isSubscribed();
    let activePlan = Auth.getActivePlan();
    const state = location.state as { competitionId?: string };
    const competitionId = state !== undefined && state.competitionId !== undefined ? parseInt(state.competitionId) : 0;
    const dispatch = useDispatch();

    useEffect(() =>
    {
        Promise.all([CompetitionsService.getCompetition(competitionId), CompetitionsService.getCompetitionBanners(competitionId)]).then(([competitionData, banners]) =>
        {
            setCompetition(competitionData);
            setBanners(banners)
        },
        (error: any) =>
        {
            setError(error);
        }).finally(() =>
        {
            setLoading(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() =>
    {
        if(competition !== undefined)
        {
            if(competition.ratioId == null || competition.ratioId === undefined)
            {
                var competitionsUsers = competition.competitionsUsers.map((competitionUser: CompetitionsUsersType) =>
                {
                    let performance = 0;
                    const valueVirtualPortfolios = competitionUser.portfolioModel.valueVirtualPortfolios;

                    if(valueVirtualPortfolios.length !== 0 && valueVirtualPortfolios[0].ammount !== 0)
                    {
                        const amountDistintInitial = valueVirtualPortfolios.filter(vVP => vVP.ammount !== valueVirtualPortfolios[0].ammount);
                        if(amountDistintInitial.length > 0)
                        {
                            performance = (amountDistintInitial[amountDistintInitial.length - 1].ammount - valueVirtualPortfolios[0].ammount) / valueVirtualPortfolios[0].ammount;
                        }
                    }
                    competitionUser.performance = performance;
                    return competitionUser;
                });

                if(competition.ratioId != null && competition.ratioId !== undefined)
                {
                    const sortedCompetitionsUsers = competitionsUsers.sort((a: CompetitionsUsersType, b: CompetitionsUsersType) => ((a.ratio ?? 0) > (b.ratio ?? 0) ? -1 : 1));
                    setCompetitionUsers(sortedCompetitionsUsers);
                }
                else
                {
                    const sortedCompetitionsUsers = competitionsUsers.sort((a: CompetitionsUsersType, b: CompetitionsUsersType) => ((a.performance ?? 0) > (b.performance ?? 0) ? -1 : 1));
                    setCompetitionUsers(sortedCompetitionsUsers);
                }
            }
            else
            {
                const sortedCompetitionsUsers = competition.competitionsUsers.sort((a: CompetitionsUsersType, b: CompetitionsUsersType) => ((a.ratio ?? 0) > (b.ratio ?? 0) ? -1 : 1));
                setCompetitionUsers(sortedCompetitionsUsers);
            }
        }
    }, [competition]);

    useEffect(() =>
    {
        if(competitionUsers !== undefined)
        {
            var seriesAux: any[] = [];
            competitionUsers.forEach((competitionUser: CompetitionsUsersType) =>
            {
                var serie: any[] = [];
                competitionUser.portfolioModel.jsonFundsData.forEach((dataAndCartLine: DataAndCartLines) =>
                {
                    serie.push(
                    {
                        name: dataAndCartLine.fund.name,
                        data: [dataAndCartLine.modelPercentage]
                    });
                });
                seriesAux.push(serie.sort((serieItemA, serieItemB) => serieItemA.data[0] - serieItemB.data[0]));
            });
            setSeries(seriesAux);
        }
    }, [competitionUsers]);

    const isCompetitionIniciated = () =>
    {
        if(competition?.startDate !== undefined && new Date(competition?.startDate) <= new Date())
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    const getPortfolioModel = async (savingPlanId?: number, portfolioModelId?: number) =>
    {
        setIsLoadingModelPortfolioToEdit(true);

        const competitionInfo: ICompetitionInfo =
        {
            name: competition!.name!,
            competitionId: competitionId,
            isPromotionated: competition!.isPromocionated!,
            origin: "edit_model_portfolio"
        };

        portfolioModelWallets.getModelWallet(portfolioModelId!).then((response: ModelWallet) =>
        {
            if(response !== undefined && response !== null)
            {
                if(response.savingPlanType === SavingsPlanTypes.FinancialEducation)
                {
                    dispatch(clearCartEP());
                    let modelPercentageTotal = 0;
                    response.jsonFundsData.map((item) =>
                    {
                        modelPercentageTotal += item.modelPercentage;
                        return dispatch(addLineEP(
                        {
                            fund: item.fund,
                            amount: 0,
                            modelPercentage: item.modelPercentage,
                            readOnly: item.readOnly,
                            savingsPlanId: item.savingPlanId,
                        }));
                    });

                    dispatch(updateModelPercentageTotal(modelPercentageTotal));
                    dispatch(cartStateEP(CartModesEP.EDIT_MODEL_PORTFOLIO));
                    dispatch(updateModelPortfolioNameEP(response.name));
                    dispatch(updateModelPortfolioIdEP(portfolioModelId!.toString()));
                    dispatch(addCompetitionDataInLs(competitionInfo));
                    history.push(
                    {
                        pathname: `/cart-ef`,
                        state:
                        {
                            savingPlanType: response.savingPlanType,
                            portfolioModelId: portfolioModelId,
                        },
                    });
                }
                else
                {
                    dispatch(clearCart());
                    let modelPercentageTotal = 0;
                    response.jsonFundsData.map((item) =>
                    {
                        modelPercentageTotal += item.modelPercentage;
                        return dispatch(addLine(
                        {
                            fund: item.fund,
                            amount: 0,
                            modelPercentage: item.modelPercentage,
                            readOnly: item.readOnly,
                            savingsPlanId: item.savingPlanId,
                        }));
                    });

                    var item: any =
                    {
                        planId: response.savingPlan.id,
                        planName: response.savingPlan?.name,
                        userId: user.id,
                        type: response.savingPlan?.type,
                        status: 4,
                        portfolio: response.savingPlan?.portfolio,
                        finametrixContract: response.savingPlan?.finametrixContract,
                        userSubscriptionId: response.savingPlan?.usersSubscriptionId
                    };

                    Auth.setActivePlan(item);
                    activePlan = Auth.getActivePlan();

                    dispatch(updateModelPercentageTotal(modelPercentageTotal));
                    dispatch(cartState(CartModes.EDIT_MODEL_PORTFOLIO));
                    dispatch(updateModelPortfolioNameEP(response.name));
                    dispatch(updateModelPortfolioIdEP(portfolioModelId!.toString()));
                    dispatch(addCompetition(competitionId));
                    dispatch(addCompetitionData(competitionInfo));
                    history.push(
                    {
                        pathname: `/cart`,
                        state:
                        {
                            savingPlanType: response.savingPlanType,
                            portfolioModelId: portfolioModelId,
                        },
                    });
                }
            }
        })
        .finally(() =>
        {
            setIsLoadingModelPortfolioToEdit(true);
            setLoading(false);
        });
    };

    return(
        <DocumentTitle title={`IronIA - Competición`}>
            <React.Fragment>
                {loading && (<Spinner size={SpinnerSize.large} />)}
                {(!loading && competition === undefined && <p>Se ha producido un error al traer la información.</p>)}
                {(!loading && competition !== undefined) &&
                (
                    <React.Fragment>
                        <section className={`${styles.competition_p}`}>
                            <BackButton />
                            <div className="ms-Grid-row">
                                <div style={{display: "flex"}}>
                                    <h2 style={{cursor: "default"}}>{competition?.name}</h2>
                                    {competitionUsers?.some(e => e.userId === user.id) && <div style={{display: "flex", justifyContent: "right", textAlign: "center"}}>
                                        {isLoadingMOdelPortfolioToEdit && (<Spinner size={SpinnerSize.large} style={{marginRight: "20px"}} />)}
                                        <PrimaryButton className="rounded" style={{width: "170px"}}
                                            onClick={() =>
                                            {
                                                const competitionFromUser = competitionUsers?.find(e => e.userId === user.id)
                                                getPortfolioModel(competitionFromUser?.savingsPlanId, competitionFromUser?.portfolioModelId);
                                            }}
                                        >
                                            Cambiar Cartera
                                        </PrimaryButton>
                                    </div>}
                                    {(!competitionUsers?.some(e => e.userId === user.id)
                                        && new Date(competition?.endDate) >= new Date()
                                        && ((competition.allowOutdatedIncriptions === true) || (competition.allowOutdatedIncriptions === false && !isCompetitionIniciated())))
                                        && <div style={{display: "flex", justifyContent: "right", width: "170px", textAlign: "center"}}>
                                            <PrimaryButton className="rounded"
                                                onClick={() =>
                                                {
                                                    if(activePlan.type === 0)
                                                    {
                                                        setError({status: true, message: "Los planes de tipo gestionado no pueden participar en la competición. Actualmente tienes seleccionado como activo un plan de este tipo."})
                                                    }
                                                    else
                                                    {
                                                        isUserSuscribed ? history.push(`/competitions/join/${competition.id}`) : history.push(`/competitions/join/nsv/${competition.id}`);
                                                    }
                                                }}
                                            >
                                                Participar
                                            </PrimaryButton>
                                        </div>
                                    }
                                </div>
                                <div className="ms-Grid-col ms-sm12" style={{marginTop: "16px", cursor: "default"}}>
                                    <div dangerouslySetInnerHTML={{__html: competition?.summary ?? ''}} />
                                </div>
                                <div className="ms-Grid-row" style={{cursor: "default"}}>
                                    <p className="ms-Grid-col ms-sm1" style={{marginTop: "20px"}}>Tipo: {CompetitionTypes[competition?.type || 0]}</p>
                                    <div className="ms-Grid-col ms-sm2" style={{marginTop: "20px", cursor: "default"}}>
                                        <p>
                                            Precio:{" "}
                                            {competition?.price === 0 && <>Inscripción gratuita &nbsp;</>}
                                            {competition?.price !== 0 && competition?.typeOfPrice === 0 &&
                                                <>{currencyNeutreFormatter.format(competition.price)}{" "} Elements IA </>
                                            }
                                            {competition?.typeOfPrice === 1 &&
                                                <>{currencyNeutreFormatter.format(competition.price)}{" "} Elements Agua</>
                                            }
                                            {(competition.typeOfPrice === 2 || competition.typeOfPrice === 3) &&
                                                <>{currencyNeutreFormatter.format(competition.price)}{" "} €</>
                                            }
                                        </p>
                                    </div>
                                    <p className="ms-Grid-col ms-sm2" style={{marginTop: "20px"}}>Métrica: {competition.ratioName !== undefined ? competition.ratioName : "Rentabilidad"}</p>
                                </div>
                            </div>
                            <div style={{display: "flex", justifyContent: "space-between", width: "100%", margin: "20px"}}>
                                <div className="ms-Grid-col ms-sm2">
                                    <CardWithInfo title="Información"
                                        body=
                                        {
                                            <div>
                                                <div>
                                                    <p>Comienzo: {competition?.startDate.split("/")[1]}/{competition?.startDate.split("/")[0]}/{competition?.startDate.split("/")[2]}</p>
                                                    <p>Final:  {competition?.endDate.split("/")[1]}/{competition?.endDate.split("/")[0]}/{competition?.endDate.split("/")[2]}</p>
                                                </div>
                                                {competition !== undefined && <CountdownTimer startDate={competition.startDate} endDate={competition.endDate} />}
                                            </div>
                                        }
                                    />
                                </div>
                                {competition?.firstPrice !== undefined &&
                                (
                                    <div className="ms-Grid-col ms-sm2">
                                        <CardWithInfo title="Primer Premio"
                                            body=
                                            {
                                                <div>
                                                    <p>{competition?.firstPrice}</p>
                                                </div>
                                            }
                                        />
                                    </div>
                                )}
                                {competition?.secondPrice !== undefined &&
                                (
                                    <div className="ms-Grid-col ms-sm2">
                                        <CardWithInfo title="Segundo Premio"
                                            body=
                                            {
                                                <div>
                                                    <p>{competition?.secondPrice}</p>
                                                </div>
                                            }
                                        />
                                    </div>
                                )}
                                {competition?.thirdPrice !== undefined &&
                                (
                                    <div className="ms-Grid-col ms-sm2">
                                        <CardWithInfo title="Tercer Premio"
                                            body=
                                            {
                                                <div>
                                                    <p>{competition?.thirdPrice}</p>
                                                </div>
                                            }
                                        />
                                    </div>
                                )}
                                <div className="ms-Grid-col ms-sm2" />
                                {
                                    competition?.specialPrice !== undefined &&
                                    (
                                        <div className="ms-Grid-col ms-sm2">
                                            <CardWithInfo title="Premio Especial"
                                                body=
                                                {
                                                    <div>
                                                        <p>{competition?.specialPrice}</p>
                                                    </div>
                                                }
                                            />
                                        </div>
                                    )
                                }
                            </div>
                            {banners !== undefined && banners?.quicklinks.length > 0 && <div className="ms-Grid-row" style={{margin: "20px"}}>
                                <L.CompetitionPatronitedPatrocin>PATROCINADORES</L.CompetitionPatronitedPatrocin>
                                <CompetitionQuickLinks quicklinks={banners?.quicklinks || []} />
                            </div>}
                            {competitionUsers && competitionUsers.length > 0 &&
                            (
                                <section className="ms-Grid-row">
                                    <div className={`${styles.tableContainer_p} background-tertiary`}>
                                        <div className={styles.tableScroll}>
                                            <table>
                                                <thead className="background-shadow">
                                                    <tr>
                                                        {isCompetitionIniciated() && <td className={styles.positionHead}>#</td>}
                                                        {isCompetitionIniciated() && <td className={styles.performanceHead}>{competition.ratioId != null ? competition.ratioName : "Rentabilidad"}</td>}
                                                        <td className={styles.nameHead}>Cartera</td>
                                                        <td className={styles.compositionHead}>Composición</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    competitionUsers.map((competitionUser, competitionUserIndex) =>
                                                    (
                                                        <tr key={`competitionUserIndex${competitionUserIndex}`}>
                                                            {isCompetitionIniciated() && <td className={styles.position}>{competitionUserIndex + 1}</td>}
                                                            {isCompetitionIniciated() && <td className={styles.performance}>{competition.ratioId != null && competition.ratioId !== undefined ? decimalFormatter.format(competitionUser.ratio ?? 0) : decimalFormatter.format(competitionUser.performance ?? 0)}</td>}
                                                            <td className={styles.name}>{competitionUser.portfolioModel.name}</td>
                                                            <td className={styles.composition}>
                                                                <HighchartsReact highcharts={Highcharts}
                                                                    options={
                                                                    {
                                                                        ...options,
                                                                        series: series[competitionUserIndex]
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </section>
                            )}
                        </section>
                        <ErrorModal title="Tu Plan actual no es compatible con la competición" btnSubmitText="Aceptar" showModal={error.status}
                            body=
                            {
                                <div>
                                    <p>{error.message}</p>
                                </div>
                            }
                            onSubmit={() =>
                            {
                                setError({status: false, message: ""});
                            }}
                            onClose={() =>
                            {
                                setError({status: false, message: ""});
                            }}
                        />
                    </React.Fragment>
                )}
            </React.Fragment>
        </DocumentTitle>
    );
};

export default CompetitionPromotionated;